import uniqBy from "lodash/uniqBy";

import {IntermediatePart} from "../intermediatePart";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {AVAILABLE_VISUALIZERS} from "../../../../config";
import store from "../../../../store";

export default class NonVisualizerSubPart extends IntermediatePart {
  constructor(isChild, partId, partName) {
    super(isChild);
    this.partId = partId;
    this.visible = true;
    this.partName = partName;
    // this.allFeaturesReceived = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new NonVisualizerSubPart(false, this.partId, dbFeature.groupName));
  }

  navigationSubItems(filters, searchText) {
    const fabricatorSubscriptions = store.getState().fabricatorState.fabricatorSubscriptions;
    const navSubItems = this.getFeaturesBySearchText(this.getFilteredFeaturesByFilters(filters), searchText)
      .map(feature => {
        Object.keys(AVAILABLE_VISUALIZERS).forEach(visualizerKey => {
          const lowerCasedKey = visualizerKey.toLowerCase();
          if (feature.partName && feature.partName.toLowerCase() === lowerCasedKey) {
            if (document.kvConfig.visualizerType === lowerCasedKey) {
              feature.notAvailableInVisualizer = false;
              feature.dbFeature.unlocked = true;
            }
            if (fabricatorSubscriptions) {
              const subscription = fabricatorSubscriptions.find(subscr => subscr.service.toLowerCase() === lowerCasedKey);
              if (subscription) {
                feature.notAvailableInVisualizer = false;
                feature.dbFeature.unlocked = true;
                if (subscription.thumbnail) {
                  feature.customThumbnail = subscription.thumbnail
                }
              }
            }
          }
        });
        return feature
      })
      .map(_ => new DesignNavigationItem(_.featureName, _));

    return uniqBy(navSubItems, (navItem) => navItem.part.dbFeature.sharedFeatureName)
  }
}
